import { Drawer, List, LoadingSkeleton } from '@boltenergy-be/design-system'
import { ReferralCodeTermsDrawerProps } from './/types'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import { useGetActiveReferralActionQuery } from 'store/api/cms-api'
import { REFERRAL_AMOUNT_GIVE, REFERRAL_AMOUNT_RECEIVE } from 'features/referral/Referral.constants'
import { Language } from 'types/language'

const ReferralCodeTermsDrawer = ({ referralCode, ...props }: ReferralCodeTermsDrawerProps) => {
  // i18n
  const { t } = useTranslation('simulation')

  // Router
  const { locale } = useRouter()

  // RTK Queries
  const { data, isLoading } = useGetActiveReferralActionQuery(
    {
      locale: locale === Language.FRENCH ? Language.FRENCH : Language.DUTCH,
      replaceNameBy: referralCode?.referrer?.firstName
    },
    {
      skip: !props.isOpen
    }
  )

  // Constants
  const amountGive = data?.reduction || REFERRAL_AMOUNT_GIVE
  const amountReceive = data?.reduction || REFERRAL_AMOUNT_RECEIVE

  return (
    <Drawer title={t('terms.referral.title')} serifTitle {...props}>
      <section className="flex-col gap-400">
        {isLoading ? (
          <LoadingSkeleton>
            <LoadingSkeleton.Paragraph lines={2} />
          </LoadingSkeleton>
        ) : (
          <p>{t('terms.referral.description', { amountGive, amountReceive })}</p>
        )}

        <List as="ul">
          {(t('terms.referral.bullets', { returnObjects: true }) as string[]).map((bullet, index) => (
            <li key={`bullet-${index}`}>{bullet}</li>
          ))}
        </List>
      </section>
    </Drawer>
  )
}

export default ReferralCodeTermsDrawer
